
<div class="container-fluid">
  <div class="row">
    <div class="col-xl-7" [ngStyle]="{'background-image': 'url(assets/images/login/visitor-management-hero.jpg)',
                                     'background-size': '700px',
                                     
                                     'background-position': 'center center',
                                     'display': 'block'}">
      <img class="bg-img-cover bg-center d-none" src="https://thereceptionist.com/your-complete-guide-visitor-management/" alt="looginpage">
    </div>
    <div class="col-lg-5 p-0">
      <div class="login-card " >
        <div>
          <div>
            <a class="logo text-left" href="#"style="justify-content: center;"> 
              <img class="img-fluid for-light" src="assets/images/logo/logo-res.png" style="height:70px; " alt="looginpage" >
              
              <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage">
               </a>
          </div>
          <h2 class="card-title font-weight-bold mb-1">Welcome to Visitor managment! 👋</h2>
              <p class="card-text mb-2">Please sign-in to your account</p>
          <div class="login-main " >
            <form class="theme-form" [formGroup]="loginForm">
           
              <p>Enter your contact number & password to login</p>
              <div class="form-group">
                <label class="col-form-label">Contact Number</label>
                <input class="form-control" type="number" required="" placeholder="contact number"
                  formControlName="contact_number">
                <div
                  *ngIf="loginForm.controls.contact_number.touched && loginForm.controls.contact_number.errors?.required"
                  class="text text-danger mt-1">
                  phone Number is required
                </div>
                <div
                  *ngIf="loginForm.controls.contact_number.touched && loginForm.controls.contact_number.errors?.contact_number"
                  class="text text-danger mt-1">
                  Invalid contact_number
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Password</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required=""
                  placeholder="*********">
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required"
                  class="text text-danger mt-1" style="padding-bottom:15px ;">
                  Password is required
                </div>
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
              </div>
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox">
                  <label class="text-muted" for="checkbox1">Remember password</label>
                </div>
                <a routerLink="/forgetPassword"class="link">Forgot password?</a>
                <button class="btn btn-primary btn-block" type="submit" [disabled]="!loginForm.valid"
                  (click)="onSubmit()">Sign in</button>
              </div>
              <!-- <h6 class="text-muted mt-4 or">Or Sign in with</h6>
              <div class="social mt-4">
                <div class="btn-showcase">
                  <a class="btn btn-light" href="https://www.linkedin.com/login" target="_blank">
                    <app-feather-icons [icon]="'linkedin'" class="txt-linkedin"></app-feather-icons> LinkedIn 
                  </a>
                  <a class="btn btn-light" href="https://twitter.com/login?lang=en" target="_blank">
                   <app-feather-icons [icon]="'twitter'" class="txt-twitter"></app-feather-icons>twitter
                  </a>
                  <a class="btn btn-light" href="https://www.facebook.com/" target="_blank">
                    <app-feather-icons [icon]="'facebook'" class="txt-fb"></app-feather-icons>facebook
                  </a>
                </div>
              </div> -->

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


